// Calix contact info
export const CUSTOMER_OPS_EMAIL = 'calixcustomerops@calix.com';

// Permissions
export const ORDER_MANAGER_PERMISSION = 'Order Manager';
export const RMA_USER_PERMISSION = 'RMA Manager (User)';
export const RMA_MANAGER_PERMISSION = 'RMA Manager (Manager)';

// External URLs
export const CART_URL = '/cart';
export const SEARCH_URL = '/search';
export const CART_NEW_URL = '/cart/new';
export const QUOTE_LIST_URL = '/quote-list';
export const ACCOUNT_SEARCH_URL = '/account-search';
export const RMA_MANAGER_URL = '/rma-manager';
export const RMA_NEW_CASE_DETAILS_URL = '/rma-manager/cases/new/details';
export const RMA_NEW_CASE_SEARCH_URL = '/rma-manager/cases/new/search?newCase=true';

// Bugsnag
export const BUGSNAG_GRAPHQL_IGNORED_OPERATIONS = [];
export const BUGSNAG_NETWORK_IGNORED_OPERATIONS = [];
export const BUGSNAG_ERROR_CLASSES = {
  DEFAULT_INFO: 'Info',
  DEFAULT_ERROR: 'Error',
  SPINNER_TIMEOUT: 'Spinner limit reached',
  USER_ERROR: 'User Error',
  USER_UNAUTHORIZED: 'User Unauthorized',
  USER_WITHOUT_ACCESSES: 'User Without Store Access',
  USER_WITHOUT_PROPER_ACCESS: 'User Without RMA Access',
  GRAPHQL_ERROR: 'GraphQL Error',
  GRAPHQL_NETWORK_ERROR: 'GraphQL Network Error',
};

// Labels
export const NOT_APPLICABLE_LABEL = 'N/A';

// Search types
export const PAST_WEEK_SEARCH_TYPE = 'dateRangePastWeek';
export const PAST_MONTH_SEARCH_TYPE = 'dateRangePastMonth';
export const CUSTOM_DATE_SEARCH_TYPE = 'dateRangeCustom';
export const OPEN_ORDERS_SEARCH_TYPE = 'openOrders';
export const PO_NUMBER_SEARCH_TYPE = 'purchaseOrderNumber';
export const SO_NUMBER_SEARCH_TYPE = 'salesOrderNumber';
export const TRACKING_NUMBER_SEARCH_TYPE = 'trackingNumber';
export const PROJECT_ID_SEARCH_TYPE = 'projectId';
export const SERIAL_NUMBER_SEARCH_TYPE = 'serialNumber';

// Cookie names
export const LOGGED_IN_JWT_COOKIE = 'LoggedInUserEcommJWT';
export const USER_REQUEST_PATH_COOKIE = 'user_request_path';

// URL query params
export const ACCOUNT_ID_PARAM = 'accountId';

export const SCHEDULE_SHIP_DATE_MESSAGE =
  'This product currently has an extended lead time. A representative from Calix will be in contact to discuss the availability of this product.';
